import { styled } from '@mui/material';
import { format } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import * as React from 'react';
import { ComponentProps, memo } from 'react';

import { useCurrentUserClientTimezone } from '../../../contexts/OidcContext/OidcContext.selectors';
import { ganttOneMinuteInMilliSeconds } from '../../Rms/RmsContent/Gantt/gantt.constants';
import { TextField } from '../TextField/TextField';

const StyledTimeField = styled(TextField)`
    input::-webkit-calendar-picker-indicator {
        filter: invert(100%);
    }
`;

export const TimeField = memo(function TimeField({
    label,
    name,
    date,
    value,
    onChange,
    inputProps,
    step,
    ...rest
}: {
    label?: string | React.ReactNode;
    name: string;
    date: number | Date; // Day
    value?: number | Date | null; // hour + minutes
    onChange?: (value: number | Date | null) => void;
    step?: number;
} & ComponentProps<typeof TextField>) {
    const timezone = useCurrentUserClientTimezone();

    return (
        <StyledTimeField
            label={
                <>
                    {label}
                    {/*<FormattedMessage id={timezone === 'UTC' ? 'form.utcTime' : 'form.localTime'} />*/}
                </>
            }
            id={name}
            name={name}
            type="time"
            {...rest}
            value={value ? format(utcToZonedTime(value, timezone || ''), 'HH:mm') : '00:00'}
            inputProps={{
                ...inputProps,
                step: step || ganttOneMinuteInMilliSeconds, // in seconds, 1 min increments
            }}
            onChange={e => {
                if (!e.target.value) {
                    onChange?.(null);
                } else {
                    const updatedTime = new Date(date).setHours(
                        parseInt(e.target.value.substring(0, 2)),
                        parseInt(e.target.value.substring(3, 5)),
                    );
                    onChange?.(zonedTimeToUtc(updatedTime, timezone || '').getTime());
                }
            }}
        />
    );
});
